import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectGroup,
  FieldSelectMaterialGroup,
  FieldSelectWasteDestinationType,
  FieldSelectWasteOriginType,
  FormFieldMultiMaterialDlg,
} from 'shared-pages';
import { FieldSelectRegion } from 'shared-pages/components/field-select/fs-region';
import { AppStore } from 'shared-pages/store/app-store';
import { useRootStore } from 'store';
import { FieldSelectAlarmType } from 'shared-pages/components/field-select/fs-alarmType';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    /* if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ identificationDocument: likeObj }],
      };
    } */

    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }
    if (values.alarmTypeId) {
      where = { ...where, alarmTypeId: values.alarmTypeId };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    collectorId: initialValues?.collectorId ?? undefined,
    alarmTypeId: initialValues?.alarmTypeId ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        {appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
        <FieldSelectAlarmType as={FormCol} name="alarmTypeId" label={t('Κατηγορία')} />
      </Row>
    </FormFilterCard>
  );
};

